import Route from '@ember/routing/route';
import { service } from '@ember/service';
import { instrumentRoutePerformance } from '@sentry/ember';
import metricValidations from 'scaleflow/validators/metric';
import { Changeset } from 'ember-changeset';
import { get } from '@ember/object';
class BusinessMetricsMetricEditRoute extends Route {
  @service store;

  metricValidator({ key, newValue }) {
    let validator = get(metricValidations, key);
    if (typeof validator === 'function') {
      return validator(key, newValue);
    }
  }

  async beforeModel() {
    await this.store.findAll('goal');
    const model = this.modelFor('business.metrics.metric');
    await model.hasMany('targets').load();
  }

  model() {
    return this.modelFor('business.metrics.metric');
  }

  async setupController(controller, model) {
    super.setupController(controller, model);
    const metricChangeset = Changeset(
      model.changeset_object,
      this.metricValidator,
    );
    controller.set('metricChangeset', metricChangeset);
  }

  resetForm(controller) {
    controller.set('activeStep', 0);
    // controller.set('selectedGoals', []);
    // controller.set('goalSearch', '');
  }

  resetController(controller, isExiting, transition) {
    if (isExiting && transition.targetName !== 'error') {
      this.resetForm(controller);
    }
  }
}

export default instrumentRoutePerformance(BusinessMetricsMetricEditRoute);
